module.exports = __webpack_public_path__ + "static/img/hzhb9.3a6c097.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hzhb9.png
// module id = htWc
// module chunks = 0